module.exports = __webpack_public_path__ + "static/media/avatar_example.86f72351.jpg";